// extracted by mini-css-extract-plugin
module.exports = {"btn":"SearchBar_btn__j-ErN","model__btn":"SearchBar_model__btn__3PsiT","inp":"SearchBar_inp__2iZq3","btmline":"SearchBar_btmline__2s4oX"};